import alertsService from './alerts.service';
import plannerFactory from './planner.factory';
import recentSearchesFactory from './recentsearches.factory';
import storageService from './storage.service';
import timetableFactory from './timetable.factory';

const moduleName = 'usc.timetable.resources';

angular.module(moduleName, [])
    .factory('alertsService', alertsService)
    .service('plannerFactory', ['$rootScope', '$filter', 'timetableService', 'storageService', 'alertsService', '$uibModal', 'timetableConfig', plannerFactory])
    .service('recentSearchesFactory', ['$rootScope', 'storageService', 'timetableConfig', recentSearchesFactory])
    .service('storageService', ['$rootScope', 'timetableConfig', 'timetableService', storageService])
    .factory('timetableService', ['$rootScope', '$http', '$q', timetableFactory]);



export default moduleName;